<template>
  <v-container fluid>
    <v-layout justify-center>
      <v-flex xs7>
        <h2 class='amaze-title'>Amaze</h2>
        <p>You're all set! You should receive an email with further instructions in a few minutes.</p>

        <v-btn color='primary' class='btn' to="/">
          Take me to the login!
        </v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<style>
</style>

<script>
export default {
  data() {
    return {};
  },
  methods: {}
};
</script>
